import React,{useState} from 'react'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { Button } from '@mui/material';
import OptionModal from './OptionModal';
import { GetUserData } from 'API/Ds Approval/api';
import { useEffect } from 'react';
// import { useEffect ,useState} from 'react';


const FieldsTable=(props)=> {
    const [option,setOption]=React.useState(null)
    const[userData,setUserData]=useState()
    const categories=["General Information","Address","Banking Details","KYC Details"]

    const handleSelect=(index)=>{
        console.log("click handled ",categories[index]);
        setOption(categories[index])
        
    }

console.log(props);

const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    console.log('open triggered');
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setOption(null);
  };

    React.useEffect(() => {
        if(option)
        handleClickOpen();
    }, [option])
    
console.log('props',props);

console.log('userdata',userData);

useEffect(()=>{
  GetUserData(props.selectedItem.user_id,setUserData)
},[])

// const getCategories=(item)=>{
//     return item._id===props.selectedItem.product_id
// }

// const getUniqueCategory=(item)=>{
//     return item._id===props.selectedItem.product_id
// }

// const product=props.configData.find(getCategories)



console.log(categories);


  return (
    <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
    <OptionModal open={open} handleClose={handleClose} userId={props.selectedItem.user_id} userData={userData} selected={option}/>
    <TableHead>
      <TableRow>
        <TableCell>Fields</TableCell>
        <TableCell align="right">Actions</TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {categories&&categories.map((row,index) => (
        <TableRow
          key={index}
          sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
        >
          <TableCell component="th" scope="row">
            {row}
          </TableCell>
          <TableCell align="right"><Button variant='contained' sx={{backgroundColor:'#A556B2'}} onClick={()=>handleSelect(index)}>View</Button></TableCell>
          
        </TableRow>
      ))}
    </TableBody>
  </Table>
  )
}

export default FieldsTable
